export enum ReportTypes {
    DESKTOP_WALLBOARD = 100,
    DASHBOARD = 110,
    ACTIVE_CALL_LIST = 0,
    HISTORIC_CALL_LIST = 1,
    UNRETURNED_LOST_CALLS = 5,
    EXTENSION_LIST = 20,
    ACD_AGENT_LIST = 21,
    HUNT_GROUP_LIST = 22,
    TRUNK_INTERFACE_LIST = 23,
    CALLS_BY_TELL_NO = 40,
    CALLS_BY_DDI = 41,
    CALLS_BY_DNIS = 42,
    TOTAL_CALL_BY_INTERVAL = 50,
    CALLS_BY_HALFHOUR_AND_DAY_INTERVAL = 51,
    CALL_BY_INTERVAL = 52,
    CALLS_BY_DAY_OF_WEEK = 55,
    CALLS_BY_ACCOUNT_CODE = 60,
    ACD_DND_ACTIVITY_LOG = 70,
    ACD_NA_CODE_USAGE = 80,
    EXTERNAL_CONTENT = 200
}

export const REPORT_TYPE_GROUPS: number[][] = [
    [ReportTypes.DASHBOARD],
    [ReportTypes.DESKTOP_WALLBOARD, ReportTypes.ACTIVE_CALL_LIST, ReportTypes.UNRETURNED_LOST_CALLS],
    [
        ReportTypes.ACD_AGENT_LIST,
        ReportTypes.EXTENSION_LIST,
        ReportTypes.HUNT_GROUP_LIST,
        ReportTypes.CALLS_BY_ACCOUNT_CODE,
        ReportTypes.CALLS_BY_DDI,
        ReportTypes.CALLS_BY_TELL_NO,
        ReportTypes.CALLS_BY_DNIS,
        ReportTypes.ACD_NA_CODE_USAGE
    ],
    [ReportTypes.HISTORIC_CALL_LIST, ReportTypes.ACD_DND_ACTIVITY_LOG],
    [
        ReportTypes.TOTAL_CALL_BY_INTERVAL,
        ReportTypes.CALLS_BY_HALFHOUR_AND_DAY_INTERVAL,
        ReportTypes.CALL_BY_INTERVAL,
        ReportTypes.CALLS_BY_DAY_OF_WEEK
    ],
    [ReportTypes.EXTERNAL_CONTENT]
]
